import "twin.macro";

import { useState } from "react";

import { Button } from "@mui/material";

import { Contained } from "@components/StyledComponents";
import DistributorModal from "@features/distributors/DistributorModal";
import DistributorTable from "@features/distributors/DistributorTable";
import { usePaginatedDistributorsQuery } from "@features/distributors/data/distributorQueries";
import Filters, { useFilterParams } from "@features/filters";
import { Title } from "@features/ui";

const AdminDistributors = () => {
  const [filters] = useFilterParams();
  const [openNewDistributorModal, setOpenNewDistributorModal] = useState(false);
  const { data: distributors, ...tableProps } = usePaginatedDistributorsQuery({
    filter: {
      name: filters.q,
    },
  });
  return (
    <>
      {openNewDistributorModal && (
        <DistributorModal
          distributor={null}
          onClose={() => setOpenNewDistributorModal(false)}
        />
      )}
      <Contained tw="space-y-6">
        <div tw="flex justify-between items-center">
          <Title>Distributors</Title>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenNewDistributorModal(true)}
          >
            Add Distributor
          </Button>
        </div>
        <Filters slots={[]} searchTitle="Search Distributors" />
        <DistributorTable
          rows={distributors}
          query={filters.q}
          {...tableProps}
        />
      </Contained>
    </>
  );
};

export default AdminDistributors;
